<template>
  <v-layout column>
    <v-card md12 xs12>
      <v-tabs
        dark
        color="cyan"
        show-arrows
      >
        <v-tabs-slider></v-tabs-slider>
        <v-tab
          v-for="(tab_item, index) in tab_list"
          :key="index"
        >
          <router-link :to="`${href}${tab_item.name}`">
            {{tab_item.label}}
          </router-link>
        </v-tab>
      </v-tabs>
      <v-tabs-items v-model="tab">
        <v-tab-item
          v-for="(tab_item, index) in tab_list"
          :key="`${tab_item.name}-${index}`"
        >
          <v-layout>
            <v-card
              v-show="tab_item.visible"
              :class="{ active: currentTab === tab_item.name }"
              :key="index">
              {{
                tab_item.count
                ? `(${inputData[tab_item.name] && Object.keys(inputData[tab_item.name]).length})`
                : ''
              }}
            </v-card>
          </v-layout>
          <clear />
        </v-tab-item>
      </v-tabs-items>
    </v-card>
  </v-layout>
</template>

<script>

export default {
  name: 'tabs',
  props: {
    /** tab_item: { name: 'children',  label: 'Children', count: true, dataRequired: 'obj_key' }  */
    tab_list: {type: Array, required: true, default: () => []},
    href: { type: String, required: true },
    inputData: { type: Object, default: () => {} },
    currentTab: { type: String, required: true},
    visible: { type: Boolean, required: false }
  },
  created() {
    this.renderTabs()
  },
  watch: {
    inputData: {
      handler: function  (value) {
        this.renderTabs()
      },
      deep: true
    }
  },
  methods: {
    renderTabs() {
      this.tab_list.forEach((tab) => {
        if (!tab.hasOwnProperty('showTab')) {
          tab.showTab = true
        }

        this.$set(tab, 'visible', tab.showTab && (!tab.dataRequired || !_.isEmpty(this.inputData[tab.name])))

      })
    }
  }

}
</script>



// WEBPACK FOOTER //
// src/components/tabs.vue